<script>
  import Plus from "../Vectors/Plus.svelte";
  import Delete from "../Vectors/Delete.svelte";
  import { fade } from "svelte/transition";
import CustomSelectBox from "./CustomSelectBox.svelte";
import { prevent_default } from "svelte/internal";
  export let Title;
  export let DeleteCallBack;
  export let RowClickCallBack;
  export let AddRowCallBack;
  export let Items;
  export let CustomActionCallBack;
  export let CustomActionName;
  let sortName;
  let desc ='1';
  function sort(x) {
    sortName=x;
    internalItems = internalItems.sort(compare);
    desc = (desc=='-1') ? '1' : '-1'
  }
  function compare(a, b) {
    if (a.columns[sortName] < b.columns[sortName]) {
      return -1 * desc;
    }
    if (a.columns[sortName] > b.columns[sortName]) {
      return 1 * desc;
    }
    return 0;
  }
var internalItems;
  $: setInternalItemsCaller = setInternalItems( Items);
  function setInternalItems(){
    internalItems = Items;
  }
  $: columnNames =
  internalItems && internalItems.length > 0 && Object.entries(internalItems[0].columns);
</script>

{#if (Title && Title.length > 0) || !(AddRowCallBack == undefined)}
  <h2 class="text-primary" style="display:block;width:100%">
    {Title}
    {#if !(AddRowCallBack == undefined)}
      <div style="float:right">
        <Plus on:click={AddRowCallBack} />
      </div>
    {/if}
  </h2>
{/if}

{#if internalItems && internalItems.length > 0}
  <div class="table-responsive">
    <table class="table table-striped table-sm list fold-out">
      <thead>
        <tr>
          {#each columnNames as colName}
            <th style="cursor:pointer; color: #51AF2F" on:click={sort(colName[0])}>{@html colName[0]} {#if sortName==colName[0]} {#if desc==-1}  <img
              alt="sort"
              title="sort"
              src="/css/assets/step-icons/chevron-double-up.svg" /> {:else} <img
              alt="sort"
              title="sort"
              src="/css/assets/step-icons/chevron-double-down.svg" />{/if}{/if}</th>
          {/each}
          {#if CustomActionName}
              <th/>
          {/if}
        </tr>
      </thead>
      <tbody>
        {#each internalItems as item}
          <tr
            title={item.description}
            in:fade={{ duration: 800 }}
            on:click={RowClickCallBack(item)}>
            {#each columnNames as colName}
              <td>
                {@html item.columns[colName[0]] || ''}
              </td>
            {/each}
            {#if DeleteCallBack}
              <td>
                <Delete on:click={DeleteCallBack(item)} />
              </td>
            {/if}
            {#if CustomActionCallBack}
            <td>
              <button class="btn btn-primary" on:click={(e)=>{CustomActionCallBack(item);e.preventDefault();e.cancelBubble=true; return true}}  >{CustomActionName}</button>
            </td>
          {/if}
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
{:else}Nog geen items{/if}
